import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaySlipComponent } from './pay-slip.component';

const routes: Routes = [
  { path: '', component: PaySlipComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaySlipRoutingModule {}
